// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3GzBY","amount":"Amount_amount__Ut2Vk","tip":"Amount_tip__3jv4p","tipHeader":"Amount_tipHeader__2wekU","tipsWrap":"Amount_tipsWrap__2gOfN"};